import httpService from '@/services/httpService'
import { convertAdvancedOptionsToURLParams } from '@/store/modules/rank-zone/Helper'
import _ from 'lodash'
// eslint-disable-next-line no-unused-vars
import Competition from '../../../features/reports/rank-zone/competition/Competition.vue'

export const types = {
  ADD_COMPETITION_DATA: 'rank-zone/ADD_COMPETITION_DATA',
  ADD_COMPARISON_TABLE_DATA: 'rank-zone/ADD_COMPARISON_TABLE_DATA',
  ADD_COMPARISON_CHART_DATA: 'rank-zone/ADD_COMPARISON_CHART_DATA',
  ADD_COMPARE_RANK_ZONE: 'rank-zone/ADD_COMPARE_RANK_ZONE'
}
const emptyCompetitionData = {
  competition: [],
  share_of_voice: [],
  competition_pie_chart: []
}
const state = {
  mainData: emptyCompetitionData,
  comparisonData: {},
  competition: [],
  compareRankZone: []
}

const mutations = {
  [ types.ADD_COMPETITION_DATA ]: function (state, { competition, share_of_voice, competition_pie_chart }) {
    sortCompetitors(competition)
    state.mainData = { competition, share_of_voice, competition_pie_chart }
  },
  [ types.ADD_COMPARISON_TABLE_DATA ]: function (state, competitionData) {
    state.competition = competitionData || []
  },
  [ types.ADD_COMPARISON_CHART_DATA ]: function (state, comparisonData) {
    state.comparisonData = { ...comparisonData }
  },
  [ types.ADD_COMPARE_RANK_ZONE ]: function (state, compareRankZone) {
    state.compareRankZone = compareRankZone
  }
}

/**
 * @param clientId
 * @param filters: {web_property_group_id, snapshot_date_1, snapshot_date_1, advancedFilters}
 * @returns {Promise<*>}
 */
const loadComparisonData = async function (clientId, filters, index) {
  const msv = JSON.parse(localStorage.getItem('msv')) || {}
  filters.msv = msv[clientId] || 1
  if (filters && filters.advancedFilters) {
    const params = convertAdvancedOptionsToURLParams(filters)
    return httpService.get(`/reports/rankzone-report/compare-competition-snapshots/${clientId}`, { params: params, tokenNameModificator: index }, { encode: false })
  }
  return httpService.get(`/reports/rankzone-report/compare-competition-snapshots/${clientId}`, { params: filters, tokenNameModificator: index })
}

const loadData = async function (clientId, filters) {
  const msv = JSON.parse(localStorage.getItem('msv')) || {}
  filters.msv = msv[clientId] || 1
  if (filters && filters.advancedFilters) {
    const params = convertAdvancedOptionsToURLParams(filters)
    return httpService.get(`/reports/rankzone-report/competition/${clientId}`, { params: params }, { encode: false })
  }
  return httpService.get(`/reports/rankzone-report/competition/${clientId}`, { params: filters })
}

/**
 * this function separates income filters into filter object with filters for two requests:
 * {@link loadData()} and {@link loadComparisonData()}
 * @param filters
 * @returns {{competitionFilters: *, comparisonFilters: *}}
 */
function getFilters (filters) {
  const comparisonFilters = _.cloneDeep(filters)
  if (!comparisonFilters.isComparing) {
    comparisonFilters.snapshot_date_2 = null
  }
  delete comparisonFilters.isComparing
  const competitionFilters = _.cloneDeep(comparisonFilters)
  competitionFilters['snapshot_date'] = comparisonFilters['snapshot_date_1']
  delete competitionFilters['snapshot_date_1']
  delete competitionFilters['snapshot_date_2']
  delete comparisonFilters.type
  return { competitionFilters, comparisonFilters }
}

function sortCompetitors (competitors) {
  competitors.sort((a, b) => {
    if (a.type === 'Clients' && b.type !== 'Clients') {
      return -1
    }
    if ((a.type === 'Clients' && b.type === 'Clients') || (a.type !== 'Clients' && b.type !== 'Clients')) {
      return 0
    }
    return 1
  })
}

const actions = {

  getCompetitionData: async function ({ commit, dispatch, state }, { clientId, filters, urlId }) {
    const { competitionFilters, comparisonFilters } = getFilters(filters)
    competitionFilters.urlId = urlId
    comparisonFilters.urlId = urlId
    commit(types.ADD_COMPARISON_TABLE_DATA, [])
    if (filters.isComparing) {
      const competitors = _.get(state, 'mainData.competition', [])
      sortCompetitors(competitors)
      if (competitors.length) {
        for (let i = 0; i < competitors.length; i++) {
          httpService.breakRequestByURL(`/reports/rankzone-report/compare-competition-snapshots/${clientId}-${i}`)
        }
      }
      const chartResponse = await loadData(clientId, competitionFilters, urlId)
      // from first request we extracting only chart data.
      // Actually we need it only on bar chart (share of voice)
      commit(types.ADD_COMPARISON_CHART_DATA, chartResponse.data)
      // in comparing mode we should send set of requests for each of competitors/clients/siblings
      if (competitors.length) {
        const comparisonTableData = []
        const promiseArray = competitors.reduce((acc, item, index) => {
          const filters = { ...comparisonFilters, web_property_group_id: item._id }
          acc.push(loadComparisonData(clientId, filters, index).then((response) => {
            if (!response || !response.data || !response.data.length) {
              return null
            }
            comparisonTableData[index * 2] = { ...item, ...response.data[0] }
            comparisonTableData[index * 2 + 1] = { ...item, ...response.data[1] }
            commit(types.ADD_COMPARISON_TABLE_DATA, [...comparisonTableData])
            return response
          }))
          return acc
        }, [])
        const response = await Promise.all(promiseArray)
        if (response.includes(null)) {
          return false
        }
        // response result should be mapped and ordered by web_property_group_id and snapshot_date
        // const result = competitors.reduce((acc, item, index) => {
        //   const comparisonData = comparisonResponse[index]
        //   if (!comparisonData || !comparisonData.data || !comparisonData.data.length) {
        //     return
        //   }
        //   acc.push({ ...item, ...comparisonData.data[0] })
        //   acc.push({ ...item, ...comparisonData.data[1] })
        //   return acc
        // }, [])
        // // here we save only competition (table) data
        // commit(types.ADD_COMPARISON_TABLE_DATA, result)
      }
    } else {
      const response = await loadData(clientId, competitionFilters, urlId)
      commit(types.ADD_COMPETITION_DATA, response.data)
    }
    return true
  },
  resetPageData: function ({ commit }) {
    commit(types.ADD_COMPARISON_TABLE_DATA, [])
    commit(types.ADD_COMPETITION_DATA, emptyCompetitionData)
    commit(types.ADD_COMPARISON_CHART_DATA, {})
  },
  getCompareRankZoneData: async function ({ commit }, { clientId, ...params }) {
    const msv = JSON.parse(localStorage.getItem('msv')) || {}
    params.msv = msv[clientId] || 1
    if (params.advancedFilters && params.advancedFilters.length) {
      params = convertAdvancedOptionsToURLParams(params)
    }
    const response = await httpService.get(`reports/rankzone-report/keyword_compare/${clientId}`, { params })
    if (!response || !response.data) {
      commit(types.ADD_COMPARE_RANK_ZONE, [])
      return null
    }
    commit(types.ADD_COMPARE_RANK_ZONE, response.data.report)
    return response.data
  },
  clearCompareRankZoneData: function ({ commit }) {
    commit(types.ADD_COMPARE_RANK_ZONE, [])
  },
  resetComparisonData: function ({ commit }, clientId) {
    const competitors = _.get(state, 'mainData.competition', [])
    sortCompetitors(competitors)
    if (competitors.length) {
      for (let i = 0; i < competitors.length; i++) {
        httpService.breakRequestByURL(`/reports/rankzone-report/compare-competition-snapshots/${clientId}-${i}`)
      }
    }
    commit(types.ADD_COMPARISON_CHART_DATA, {})
    commit(types.ADD_COMPARISON_TABLE_DATA, [])
  }
}

/**
 * Store for manage Competition Data in {@link Competition} component
 */
export default {
  namespaced: true,
  state,
  actions,
  mutations
}
